import {PunkRocker} from "../../../PunkRocker";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {StartPresentation} from "../general/StartPresentation";
import {PREngineController} from "../../../punkEngine/PREngineController";
import {GameData} from "../../../server/data/GameData";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {PRGameMode} from "../../../server/PRGameMode";
import {PunkSymbol} from "../../../punkEngine/symbol/PunkSymbol";
import {SoundManager} from "../../../sound/SoundManager";
import {GameConfig} from "../../../config/base/GameConfig";

export class NormalStartPresentation extends StartPresentation {

    protected gameData: GameData;
    protected nextMode: GameMode;

    setGamedData(data: any) {
        this.gameData = data;
        this.nextMode = data.nextMode;
        PunkRocker.waysCounter.setGameData(data);
    }

    preStart(): void {
        SoundManager.reset();
        this.normalStart();

        // #396
        GameConfig.xWILD_PRESENTATION_STARTED = false;

        super.preStart();
        PREngineManager.RSAll((r, s) => {
            if (r.isActive) {
                s.onSpinStart();
            }
        });
    }

    normalStart(): void {
        PREngineManager.RAll(r => r.changeReelAmount(3));
        PunkRocker.counter.remove();
        console.log(this.gameData.Reel);

        // #319 -> want it to reset for every mode, including reSpins.
        PunkRocker.SYMBOLS_NUM_IN_REEL = [3, 3, 3, 3, 3, 3];

        if (this.gameData.nextMode === PRGameMode.NORMAL) {
            PunkRocker.waysCounter.setValue(undefined, Math.pow(3, 6), 0.25);
        } else {
            const reelSize: number = this.gameData.Reel.calculateMultiWaysValues(this.gameData.nextMode)[0];
            PunkRocker.waysCounter.setValue(undefined, reelSize, 0.25);
        }

        PunkRocker.waysCounter.stopLoop();
    }

    createPresentation() {
        //#125 convert scatters to molotov wilds after spin start
        const currMode: PRGameMode = this.gameData.mode,
            nextMode: PRGameMode = this.gameData.nextMode,
            wildExpandSoundPlayedRowWise: boolean[] = [false, false, false];

        if (nextMode === PRGameMode.RESPIN || currMode === PRGameMode.RESPIN) {
            PREngineManager.AllReels.forEach(currReel => {

                currReel.AllWindowSymbols.forEach(currSym => {
                    if (currSym.isWild && nextMode === PRGameMode.RESPIN && !(currSym.isWildFireOn)) {
                        currSym.triggerWild(true);
                    }
                    if (currSym.isScatter) {
                        let delay = 0.6;
                        for (let currSymPosId: number = currSym.posID[0]; currSymPosId >= 0; currSymPosId--) {
                            this.timeline.add(() => {
                                const symToTransform: PunkSymbol | undefined = currReel.getSymbol(currSymPosId);
                                symToTransform!.hideRiotSpine();
                                symToTransform!.WildTransform();
                            }, delay);

                            // #180
                            if (!wildExpandSoundPlayedRowWise[currSymPosId]) {
                                wildExpandSoundPlayedRowWise[currSymPosId] = true;
                                this.timeline.add(() => {
                                    SoundManager.playWildTransformSound(true);
                                }, delay);
                            }
                            
                            delay += 0.1;
                        }
                    }
                });
            });
        }

        if (PunkRocker.jumpWilds.isStillActive) {
            if (PunkRocker.jumpWilds.isStillActive) {
                this.timeline.add(PunkRocker.jumpWilds.jumpToReset())
            }
        } else {
            this.startReels();
            this.PresentationState.setInactive();
        }
    }

    addExtraForStart(reel: PREngineController): void {
        reel.setGraphAlpha(0.25, reel.startDuration);
        reel.AllWindowSymbols.forEach(s => s.onSpinStart())
    }

    skip(): void {
        // RoadRageEngineManager.isQuickStop = true;
    }

    done(): void {
    }
}